const questions = [
  {
    id: "ionizer_type__c",
    title: "What type of ionizer?"
  },
  {
    id: "installation_location__c",
    title: "Where will the equipment be installed?"
  },
  {
    id: "dry_contact__c",
    title: "BAS Dry Contacts?"
  },
  {
    id: "pollutant_load_factor__c",
    title: "What is the pollutant load factor?"
  },
  {
    id: "cfm_ranges",
    title: "What is the supply airflow?(CFM)"
  },
  {
    id: "available_voltage__c",
    title: "What is the voltage?",
  }
]


export { questions }
